import script from "./AutoSeedBracketsModal.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./AutoSeedBracketsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoSeedBracketsModal.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./AutoSeedBracketsModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__